import styled from "styled-components";

export const FootNoteContainer = styled.div`
  padding: 10px;
`;
